import "./datatable.scss";
import { DataGrid } from "@mui/x-data-grid";
import { userColumns, userRows } from "../../datatablesource";
import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import useFetch from "../../hooks/useFetch";
import axios from "axios";
import Swal from 'sweetalert2'

const Datatable = ({ columns }) => {
  const location = useLocation();
  const path = location.pathname.split("/")[1];
  const [list, setList] = useState();
  const { data, loading, error } = useFetch(`/${path}`);
  console.log("data=>", data);
  useEffect(() => {
    setList(data);
  }, [data]);

  console.log(path)
  const handleDelete = async (id) => {
    try {
      if(path=="rooms"){
      await axios.delete(`https://dummy-app-link.herokuapp.com/api/rooms/${id}`)
      .then(e=>{
        if(e.status==200){
          setTimeout(() => {
                Swal.fire({
          icon: 'success',
          title: 'Deleted successfully',
          showConfirmButton: false,
          position: 'top-end',
          timer: 2000
        })
          }, 1000);
    
      }
        console.log("hotels=>",e)
      })
      }
      else if(path=="hotels"){
        await axios.delete(`https://dummy-app-link.herokuapp.com/api/hotels/${id}`)
        .then(e=>{
          if(e.status==200){
            setTimeout(() => {
          Swal.fire({
            icon: 'success',
            title: 'Deleted successfully',
            showConfirmButton: false,
            position: 'top-end',
            timer: 2000
          })
        }, 1000);

        }
          console.log("hotels=>",e)
        })
      }
      else{
      await axios.delete(`https://dummy-app-link.herokuapp.com/api/${path}/${id}`);
      }
      setList(list.filter((item) => item._id !== id));
    } catch (err) {}
  };

//   const handleView = async (id) => {
// console.log("id=>",id);
//   };

  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 200,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            {/* <Link to="/users/test" style={{ textDecoration: "none" }}>
              <div className="viewButton"
                      onClick={() => handleView(params.row)}
                      >View</div>
            </Link> */}
                {/* <Link to="/users/test" style={{ textDecoration: "none" }}> */}
              <div className="viewButton"
                      // onClick={() => handleView(params.row)}
                      > Edit </div>
            {/* </Link> */}
            <div
              className="deleteButton"
              onClick={() => handleDelete(params.row._id)}
            >
              Delete
            </div>
          </div>
        );
      },
    },
  ];
  return (
    <div className="datatable">

      <div className="datatableTitle">
        {path.charAt(0).toUpperCase() + path.slice(1)} List
        <Link to={`/${path}/new`} className="link">
          Add New
        </Link>
      </div>
      {/* {data.length } */}

      <br />

      {data.length ? (
        <DataGrid
          className="datagrid"
          rows={list}
          columns={columns.concat(actionColumn)}
          pageSize={9}
          rowsPerPageOptions={[9]}
          checkboxSelection
          getRowId={(row) => row._id}
        />
      ) : (
        <img
          style={{
            height: 100,
            justifyContent: "center",
            alignContent: "center",
          }}
          src="https://cdn.dribbble.com/users/3337757/screenshots/6825268/076_-loading_animated_dribbble_copy.gif"
        />
      )}
    </div>
  );
};

export default Datatable;
